module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Cooking/Knife#1-de94ee535606fbb00b0bea222bb78053.svg";